import { Box, Chip, Typography } from '@mui/material'
import { statusOptions } from '../../definitions/Approval'

const STATUS_COLORS: Record<string, string> = {
    'approved': 'success.main',
    'ready-for-review': 'info.main',
    'rejected': 'red',
    'draft': 'orange'
}

const getStatusLabel = (value: string) =>
    statusOptions.find(o => o.value === value)?.label ?? value

const StatusChip = ({ status }: { status: string }) => {
    const color = STATUS_COLORS[status]
    const label = getStatusLabel(status)

    return (
        <Chip
            variant='outlined'
            size='small'
            label={(
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                        sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: color, flexShrink: 0 }}
                    />
                    <Typography variant='body2'>{label}</Typography>
                </Box>
            )}
        />
    )
}

export default StatusChip
